import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import * as paymentBatchCrud from "../../../../crud/paymentBatch.crud";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import { Badge } from "react-bootstrap";
import CurrencyBatchModal from './CurrencyBatchModal/CurrencyBatchModal';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, contract) => {
    const formFields = [];
    
    formFields.push({
        caption: fields.ApplicationType.label,
        dataField: 'paymenttype',
        required: fields.ApplicationType.required,
        dataType: 'list',
        options: {
            dataSource: fields.ApplicationType.configurableTypeFields,
            valueExpr: 'value',
            displayExpr: 'display'
        }
    });

    formFields.push(
        {
            caption: fields.AssessmentDate.label,
            dataField: 'assessmentdatedisplay',
            required: fields.AssessmentDate.required,
            dataType: 'date',
        },
        {
            caption: fields.Summary.label,
            dataField: 'summary',
            required: fields.Summary.required,
            dataType: 'long-string',
        }
    );

    //batchPaymentForPackagedContractEnabled
    if (fields.ProjectOrders.visible) {
        formFields.push({
            caption: fields.ProjectOrders.label,
            dataField: 'projectorderid',
            required: fields.ProjectOrders.required,
            dataType: 'integer',
        });
    }

    formFields.push(
        {
            caption: fields.OtherCumulativePrice.label,
            dataField: 'othercumulativeprice',
            required: fields.OtherCumulativePrice.required,
            dataType: 'money',
        },
        {
            caption: fields.OtherAmountPaid.label,
            dataField: 'otheramountpaid',
            required: fields.OtherAmountPaid.required,
            dataType: 'money',
        },
        {
            caption: fields.SubTotalRetain.label,
            dataField: 'subtotalretain',
            required: fields.SubTotalRetain.required,
            dataType: 'money',
        }
    );

    if (contract?.totalcertified == null) {
        formFields.push({
            caption: fields.LastPaymentCertificateAmount.label,
            dataField: 'lastpaymentcertificateamount',
            required: fields.LastPaymentCertificateAmount.required,
            dataType: 'money'
        });
    }

    if (fields.OtherTaxAmount.visible) {
        formFields.push({
            caption: fields.OtherTaxAmount.label,
            dataField: 'othertaxamount',
            required: fields.OtherTaxAmount.required,
            dataType: 'money',
        });
    }

    if (fields.PurchaseOrderNumber.visible) {
        formFields.push({
            caption: fields.PurchaseOrderNumber.label,
            dataField: 'purchaseordernumber',
            required: fields.PurchaseOrderNumber.required,
            dataType: 'integer',
        });
    }

    return formFields;
}

class PaymentBatchList extends BaseListPage {
    constructor(props) {
        super(props);
        this.state = {
            notifications: null,
            showWizard: false
        };

        this.multipleCurrencyWizardEnabled = props.workflowItem.userFilters.mainNotice.createAllowed;

        this.batchPaymentForPackagedContractEnabled = props.workflowsQA['72'] && props.contract.ispackaged;

        this.additionalButtons = [];
        if (this.multipleCurrencyWizardEnabled) {
            this.additionalButtons.push(
                {
                    location: "after",
                    locateInMenu: "auto",
                    widget: "dxButton",
                    options:
                    {
                        icon: "plus",
                        onClick: () => { this.setState({ showWizard: true }) },
                        text: "Create Batch",
                    }
                }
            );
        }

        this.columns = [
            { caption: "Reference ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.CREATED_DATE", dataField: "createdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby" },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "communicateddate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
        ];

        this.batchFormFields = getBatchFormFields(props.workflowItem.fields, props.contract);
    }

    componentDidMount() {
        super.componentDidMount();
        this.loadPaymentBatches();
        if (window.location.hash === "#wizard") {
            //remove hash from URL
            window.history.replaceState("", document.title, window.location.pathname);
            this.setState({ showWizard: true })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps) {
            if (window.location.hash === "#wizard") {
                //remove hash from URL
                window.history.replaceState("", document.title, window.location.pathname);
                this.setState({ showWizard: true })
            }
        }
    }
    loadPaymentBatches = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: responseObj } = await paymentBatchCrud.getRegisterList(contractid, this.props.workflowItem.config.currentModelType);
            let listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
                responseObj :
                responseObj.filter(ntf => ntf.communicated === true);
            this.setState({ notifications: listData });
        } catch (error) {
            console.log(error);
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.paymentbatchid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        switch (cellInfo.data.status) {
            case 'NOT_COMMUNICATED':
                badgeVariant = 'secondary';
                break;
            case 'COMMUNICATED':
                badgeVariant = 'success';
                break;
            default:
                break;
        }
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        if (rowData.status) {
            return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
        }
        else {
            return "";
        }
    }

    onCurrencyBatchClosed = () => {
        this.setState({ showWizard: false }, () => {
            this.loadPaymentBatches();
        });
    }

    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={this.batchPaymentForPackagedContractEnabled && this.props.workflowItem.userFilters.mainNotice.createAllowed}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={paymentBatchCrud.importPaymentCertificates}
                        batchDeleteEndpoint={paymentBatchCrud.deletePaymentCertificateDrafts}
                        batchCommunicateEndpoint={paymentBatchCrud.communicatePaymentCertificateDrafts}
                        onBatchRecordsUpdated={this.loadPaymentBatches}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.workflowItem.pageTitle}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="paymentbatchid"
                        columns={this.columns}
                        additionalToolbarItems={this.additionalButtons}
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        workflowItem={this.props.workflowItem}
                    />
                </PortletBody>
                {
                    this.multipleCurrencyWizardEnabled && (
                        <CurrencyBatchModal
                            {...this.props}
                            visible={this.state.showWizard}
                            onClose={this.onCurrencyBatchClosed}
                        />
                    )
                }
            </Portlet>
        );
    }
}

export default withListPageProps(PaymentBatchList);
